module.exports = __webpack_public_path__ + "static/media/googlePay.5d7490d7.svg";